import { render } from "./ButtonGroup.vue?vue&type=template&id=43b88aa8"
import script from "./ButtonGroup.vue?vue&type=script&lang=ts"
export * from "./ButtonGroup.vue?vue&type=script&lang=ts"
script.render = render

export default script